

import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {StateFeeRequirementViewModel} from "@/api-client";

@Component({})
export default class TransferPaymentInfo extends Vue {
  @Prop({required: true})
  requirement!: StateFeeRequirementViewModel;
  
}
